import PostCard from '@/components/PostCard';
import {
  fetchBusker,
  fetchPostsForBusker,
  subscribeToBusker,
  unsubscribeFromBusker,
} from '@/services/supabase-service';
import { Busker, Post } from '@/types/type';
import { FontAwesome, MaterialCommunityIcons } from '@expo/vector-icons';
import { Image } from 'expo-image';
import { router, useLocalSearchParams } from 'expo-router';
import React, { useEffect, useState } from 'react';
import { FlatList, SafeAreaView, Text, TouchableOpacity, View } from 'react-native';

const BuskerDetailsScreen = () => {
  const PAGE_SIZE = 2;
  const [posts, setPosts] = useState<Post[]>([]);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [currentBusker, setCurrentBusker] = useState<Busker | null>(null);
  const { route, id } = useLocalSearchParams();
  const buskerId = Array.isArray(id) ? id[0] : id;

  useEffect(() => {
    const fetchData = async () => {
      const selectedBusker = await fetchBusker(buskerId);
      setCurrentBusker(selectedBusker);
    };
    fetchData();
  }, [id]);

  const onRefresh = async () => {
    if (!loading && hasMore && buskerId) {
      setRefreshing(true);
      setLoading(true);
      const newPosts = await fetchPostsForBusker(buskerId, PAGE_SIZE, posts.length);
      setPosts([...posts, ...newPosts]);
      setHasMore(newPosts.length > 0);
      setRefreshing(false);
      setLoading(false);
    }
  };

  const isLongText = currentBusker?.description ? currentBusker.description.length > 200 : false;
  const [isExpanded, setIsExpanded] = useState(false);
  const [isSubscribed, setSubscribed] = useState(false);

  const OnSubscribePress = () => {
    if (currentBusker?.id) {
      if (isSubscribed) {
        unsubscribeFromBusker(currentBusker.id);
        setSubscribed(false);
        currentBusker.subscribed = false;
        console.log('Unsubscribed');
      } else {
        subscribeToBusker(currentBusker.id);
        currentBusker.subscribed = true;
        setSubscribed(true);
        console.log('Subscribed');
      }
    }
  };

  useEffect(() => {
    const Subscription = async () => {
      if (currentBusker?.id) {
        setSubscribed(currentBusker.subscribed ?? false);
      }
    };

    Subscription();
  }, [currentBusker]);

  return (
    <SafeAreaView className="h-full w-full">
      <FlatList
        ListHeaderComponent={
          <View className="items-center">
            <View style={{ padding: 16 }}>
              <View className="mb-4">
                <Text style={{ fontSize: 40, fontWeight: 'bold' }}>{currentBusker?.full_name}</Text>
              </View>
              <Text>{currentBusker?.description}</Text>

              <View style={{ marginBottom: 24 }}>
                <Text
                  style={{ fontSize: 14, lineHeight: 20 }}
                  numberOfLines={isExpanded ? undefined : 3}>
                  {currentBusker?.description}
                </Text>
                {isLongText && (
                  <TouchableOpacity onPress={() => setIsExpanded(!isExpanded)}>
                    <Text style={{ color: '#003566', marginTop: 4 }}>
                      {isExpanded ? ' Read Less...' : ' Read More...'}
                    </Text>
                  </TouchableOpacity>
                )}
              </View>

              <View className="mt-4 w-full">
                {currentBusker?.media_urls?.map((item, index) => (
                  <View key={index}>
                    <Text>
                      {item.url} {index}
                    </Text>
                    <Image
                      source={{ uri: item.url }}
                      className="w-full h-[250px]"
                      contentFit="contain"
                    />
                  </View>
                ))}
              </View>
            </View>

            <TouchableOpacity className="absolute top-4 right-4" onPress={OnSubscribePress}>
              {isSubscribed ? (
                <FontAwesome name="bookmark" size={24} color="black" />
              ) : (
                <FontAwesome name="bookmark-o" size={24} color="black" />
              )}
            </TouchableOpacity>
          </View>
        }
        contentContainerStyle={{ paddingBottom: 70 }}
        data={posts}
        renderItem={({ item }) => <PostCard key={item.id} post={item} />}
        keyExtractor={(item) => item.id?.toString() || String(Math.random())}
        onEndReached={onRefresh}
        onEndReachedThreshold={0}
        refreshing={refreshing}
        onRefresh={onRefresh}
      />
      <TouchableOpacity
        onPress={() => {
          router.push(`./../post-create?busker_id=${buskerId}`);
        }}
        className="absolute bottom-0 right-0 p-4 bg-blue-500 rounded-full">
        <MaterialCommunityIcons name="plus" size={24} />
      </TouchableOpacity>
    </SafeAreaView>
  );
};

export default BuskerDetailsScreen;
